jQuery.noConflict();
jQuery(document).ready(function() {
    if( $('.sliderquote').length > 0 ) { 
        $('.sliderquote_elements').owlCarousel({
            loop: false,
            items: 1,
            responsive : {
                // breakpoint from 0 up
                0 : {
                    nav: false,
                    dots: true,
                },
                // breakpoint from 425 up
                1024 : {
                    nav: true,
                    dots: false,
                    navText: ["<img src='../wp-content/themes/index/assets/images/icons/Left_Arrow_White.png'>","<img src='../wp-content/themes/index/assets/images/icons/Right_Arrow_White.png'>"],
                }
            }
        });
    }
});
